import { SortKey, SortStatus, Tracker } from "../types";

const EmptySort: TrackersPageSortState = {
    sort_name: null,
    sort_hardwareId: null,
    sort_battery: null,
    sort_version: null,
    sort_last: null,
    sort_server: null,
};

type TrackersPageSortState = {
    sort_name: SortStatus;
    sort_hardwareId: SortStatus;
    sort_battery: SortStatus;
    sort_version: SortStatus;
    sort_last: SortStatus;
    sort_server: SortStatus;
}

const LOCALSTORAGE_SORT_KEY = 'RedirectionSort';
const item = localStorage.getItem(LOCALSTORAGE_SORT_KEY);

const SORTER: TrackersPageSortState = item ? JSON.parse(item) : {
    ...EmptySort,
};

function sort(t1: Tracker, t2: Tracker): number {
    if (SORTER.sort_name === 'ASC') {
        return t1.name < t2.name ? -1 : 1;
    }
    if (SORTER.sort_name === 'DESC') {
        return t1.name < t2.name ? 1 : -1;
    }
    if (SORTER.sort_hardwareId === 'ASC') {
        return t1.hardware_id < t2.hardware_id ? -1 : 1;
    }
    if (SORTER.sort_hardwareId === 'DESC') {
        return t1.hardware_id < t2.hardware_id ? 1 : -1;
    }
    if (SORTER.sort_battery === 'ASC') {
        return t1.battery < t2.battery ? -1 : 1;
    }
    if (SORTER.sort_battery === 'DESC') {
        return t1.battery < t2.battery ? 1 : -1;
    }
    if (SORTER.sort_version === 'ASC') {
        return t1.version < t2.version ? -1 : 1;
    }
    if (SORTER.sort_version === 'DESC') {
        return t1.version < t2.version ? 1 : -1;
    }
    if (SORTER.sort_last === 'ASC') {
        return t1.last < t2.last ? -1 : 1;
    }
    if (SORTER.sort_last === 'DESC') {
        return t1.last < t2.last ? 1 : -1;
    }
    if (SORTER.sort_server === 'ASC') {
        return t1.server_url < t2.server_url ? -1 : 1;
    }
    if (SORTER.sort_server === 'DESC') {
        return t1.server_url < t2.server_url ? 1 : -1;
    }
    return t1.id < t2.id ? -1 : 1;
}

function set(code: SortKey, status: SortStatus): void {
    Object.keys(SORTER).map(code => SORTER[code as SortKey] = null);
    SORTER[code] = status;
    localStorage.setItem(LOCALSTORAGE_SORT_KEY, JSON.stringify(SORTER))
}

function get(code: SortKey): SortStatus {
    return SORTER[code];
}

const SorterService = {
    sort,
    set,
    get,
}

export default SorterService;
